import React from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
import { FormattedMessage } from "react-intl";

import { Button } from "src/common/components/Button";
import { mapPathToString } from "src/common/utils/common";
import { genericMessages } from "src/messages/generic";

import "./FieldList.css";

interface FieldListProps {
	path?: (string | number)[];
}

export const FieldList: React.FunctionComponent<
	React.PropsWithChildren<FieldListProps>
> = ({ path, children }) => (
	<div className="field-list" data-fyrms={mapPathToString(path)}>
		{children}
	</div>
);

export const FieldListItem: React.FunctionComponent<
	React.PropsWithChildren
> = ({ children }) => <div className="field-list-item">{children}</div>;

export const FieldListInput: React.FunctionComponent<
	React.PropsWithChildren
> = ({ children }) => <div className="field-list-input">{children}</div>;

interface AddFirstButtonProps {
	disabled?: boolean;
	onClick(): unknown;
}

export const AddFirstButton: React.FunctionComponent<AddFirstButtonProps> = ({
	disabled,
	onClick
}) => (
	<Button
		type="button"
		disabled={disabled}
		variant="secondary"
		onClick={onClick}
	>
		<FormattedMessage {...genericMessages.add} />
	</Button>
);

interface AddButtonProps {
	disabled?: boolean;
	onClick(): unknown;
}

export const AddButton: React.FunctionComponent<AddButtonProps> = ({
	disabled = false,
	onClick
}) => (
	<Button
		variant="secondary"
		type="button"
		disabled={disabled}
		onClick={onClick}
	>
		<FaPlus />
	</Button>
);

interface RemoveButtonProps {
	disabled?: boolean;
	onClick(): unknown;
}

export const RemoveButton: React.FunctionComponent<RemoveButtonProps> = ({
	disabled = false,
	onClick
}) => (
	<Button
		variant="secondary"
		type="button"
		disabled={disabled}
		onClick={onClick}
	>
		<FaMinus />
	</Button>
);
